import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import snakeCaseKeys from 'snakecase-keys';

import { createOtherRequestRequest } from '../../../requests/otherRequests';
import { sendAlert } from '../../../actions/utils';
import OtherRequestForm from '../../Shared/OtherRequest/OtherRequestForm';

const basicOtherRequest = {
  employeeId: '',
  otherRequestTypeId: '',
  dateFrom: '',
  dateTo: '',
  additional: '',
  reason: '',
  directApprove: false,
  rrhh: false
};

const OtherRequestNew = ({
  onSuccess,
  action,
  employeeId,
  rrhh = false,
  directApprove = false
}) => {
  const dispatch = useDispatch();

  useEffect(() => window.scrollTo(0, 0), []);

  const handleSuccessCreate = () => {
    dispatch(sendAlert({ kind: 'success', message: 'Solicitud creada con éxito' }));
    onSuccess();
  };

  const handleCreateRequest = (params, setSubmitting) => {
    const snakeCaseOtherRequest = snakeCaseKeys(params);

    createOtherRequestRequest({
      dispatch,
      params: {
        ...snakeCaseOtherRequest
      },
      successCallback: handleSuccessCreate,
      callback: () => setSubmitting(false)
    });
  };

  return (

    <Row>
      <Col>
        <OtherRequestForm
          action={action || 'new'}
          otherRequest={{ ...basicOtherRequest, directApprove: rrhh || directApprove, rrhh }}
          employeeId={employeeId}
          formRequest={handleCreateRequest}
          rrhh={rrhh}
        />
      </Col>
    </Row>
  );
};

export default OtherRequestNew;